import { useRef, Fragment } from 'react';
import PropTypes from 'prop-types';

// Material UI
import { TextField, Tooltip, IconButton, Icon } from '@mui/material';

// Utils
import { SwalImage } from '@utils/alerts';

const TextFieldFiles = (props) => {
  const {
    name = 'archivo',
    label = 'Archivo',
    allowTypes = '.png,.jpg,.jpeg,.webp',
    values = { fileName: '', file: null },
    setValues = () => {},
    useFileName = false,

    isMultiple = false,
    clear = { file: null, fileName: '' },
    ...others
  } = props;

  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const updFile = e.target.files[0];
    e.target.value = null;

    if (updFile) {
      const reader = new FileReader();

      reader.onloadend = () => {
        const file = reader.result;
        const fileName = updFile.name.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9-_.]/g, '');

        let newValues = { ...values };

        if (isMultiple) {
          newValues.files = [
            ...(values.files || []).filter((f) => f.fileName !== fileName),
            { fileName, file },
          ];
        } else {
          newValues.file = file;

          if (useFileName) newValues.fileName = fileName;
        }

        setValues(newValues);
      };

      reader.readAsDataURL(updFile);
    }
  };

  const handleFileClear = (e) => {
    e.stopPropagation();

    let newValues = { ...values };

    if (isMultiple) newValues.files = [];
    else {
      newValues.file = clear?.file !== undefined ? clear.file : null;
      if (useFileName) newValues.fileName = clear?.fileName !== undefined ? clear.fileName : '';
    }

    setValues(newValues);
  };

  const handleFileView = (e) => {
    e.stopPropagation();
    SwalImage({ image: values.file || values.fileURL, title: values.fileName, small: true });
  };

  const handleClick = () => fileInputRef.current.click();

  return (
    <Fragment>
      <TextField
        fullWidth
        size="small"
        name={name || 'archivo'}
        label={label || 'Archivo'}
        onClick={handleClick}
        onChange={handleClick}
        value={values.fileName ?? values.file ? 'Archivo nuevo' : values.fileURL ? 'Archivo anterior' : ''}
        InputProps={{
          endAdornment: (
            <>
              <Tooltip title="Elegir imagen" disableInteractive arrow>
                <IconButton
                  size="small"
                  component="span"
                  aria-label="upload file"
                  color="primary"
                  disabled={others?.disabled}
                >
                  <Icon>upload_file</Icon>
                </IconButton>
              </Tooltip>

              {(values.file || values.fileName || values.fileURL) && (
                <>
                  {!isMultiple && (values.file || values.fileURL) && (
                    <Tooltip title="Ver imagen" disableInteractive arrow>
                      <IconButton
                        size="small"
                        component="span"
                        aria-label="view file"
                        color="success"
                        onClick={handleFileView}
                      >
                        <Icon>visibility</Icon>
                      </IconButton>
                    </Tooltip>
                  )}

                  <Tooltip title={'Limpiar imagen' + (isMultiple ? 'es' : '')} disableInteractive arrow>
                    <IconButton
                      size="small"
                      component="span"
                      aria-label="clear files"
                      color="error"
                      onClick={handleFileClear}
                      disabled={others?.disabled}
                    >
                      <Icon>clear</Icon>
                    </IconButton>
                  </Tooltip>
                </>
              )}
            </>
          ),
        }}
        {...others}
      />

      <input
        name={name || 'archivo'}
        type="file"
        ref={fileInputRef}
        accept={allowTypes || '.png,.jpg,.jpeg,.webp'}
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
    </Fragment>
  );
};

TextFieldFiles.propTypes = {
  values: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
  useFileName: PropTypes.bool,
  isMultiple: PropTypes.bool,
  clear: PropTypes.shape({ file: PropTypes.any, fileName: PropTypes.string }),
};

export default TextFieldFiles;
